import {
    VideoRoomPluginHandler,
    Publisher,
    VideoRoomPluginRoomAlreadyExistsError,
    ParticipantId,
    RoomId,
} from '../../plugins/VideoRoomPlugin';
import { Session } from '../../core';

export class VideoRoomParticipant {
    protected readonly pluginHandler: VideoRoomPluginHandler;
    private _privateId: string | undefined;
    onpublishers?: (publishers: Publisher[]) => void;
    onunpublished?: (publisherId: ParticipantId) => void;

    get privateId(): string | undefined {
        return this._privateId;
    }

    static async create(session: Session, opaqueId: string) {
        const pluginHandler = await VideoRoomPluginHandler.create(
            session,
            opaqueId
        );
        return new VideoRoomParticipant(pluginHandler);
    }

    constructor(pluginHandler: VideoRoomPluginHandler) {
        this.pluginHandler = pluginHandler;

        pluginHandler.addListener({
            onpublish: data => this.handleOnPublishers(data.publishers),
            onunpublished: data => this.handleOnUnpublished(data.unpublished),
        });
    }

    async join(room: RoomId, display: string) {
        try {
            await this.pluginHandler.createRoom(room);
        } catch (e) {
            if (e instanceof VideoRoomPluginRoomAlreadyExistsError) {
                // ok
            } else {
                console.error(e);
                return;
            }
        }

        const data = await this.pluginHandler.joinPublisher(room, display);
        this._privateId = data.private_id;
        this.handleOnPublishers(data.publishers);
    }

    async leave() {
        this.pluginHandler.leave();
    }

    private handleOnPublishers(publishers: Publisher[]) {
        if (this.onpublishers) {
            this.onpublishers(publishers);
        } else {
            console.warn('new publishers', publishers);
        }
    }

    private handleOnUnpublished(publisherId: ParticipantId) {
        if (this.onunpublished) {
            this.onunpublished(publisherId);
        } else {
            console.warn('unpublished', publisherId);
        }
    }
}
